import { render } from "./Footer1.vue?vue&type=template&id=4294fc29&scoped=true"
import script from "./Footer1.vue?vue&type=script&lang=js"
export * from "./Footer1.vue?vue&type=script&lang=js"

import "./Footer1.vue?vue&type=style&index=0&id=4294fc29&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/texnoelm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4294fc29"]])

export default __exports__